import React, {useState} from "react"

import "../../page/Shop/Shop.css"

import ShopProgress from "./ShopProgress"
import TermsModal from "../Modal/TermsModal";
import {useFetcher} from "react-router-dom";

function InfoCheck({user, setStep}) {

	const [confirmPrice, setConfirmPrice] = useState(false)
	const [agreePrivacy, setAgreePrivacy] = useState(false)
	const [agreeCancel, setAgreeCancel] = useState(false)

	const [openCancelTermModal, setOpenCancelTermModal] = useState(false)
	const [termsOpen, setTermsOpen] = useState(false)

	const isValid = confirmPrice && agreePrivacy && agreeCancel

	return (
		<>
			<div className="cardContent infoCheck">
				<form className="cardForm" name="infoCheck">
					<ShopProgress isThird={true} />
					<section>
						<h4>주문자 정보확인</h4>
						<p>정확한 주문을 위해 아래의 회원정보를 다시 한 번 확인해 주시기 바랍니다.</p>
						<ul className="infoList">
							<li>
								<h5>이메일 계정</h5> <span>{user?.email}</span>
							</li>
							<li>
								<h5>구매자격</h5>
								<span>
									{user?.certificates?.map((item, index) => {
										return (
											<div style={{marginBottom: 4}}>{item?.certificateType?.name}</div>
										)
									})}
								</span>
							</li>
							<li>
								<h5>회원이름</h5> <span>{user?.name?.slice(0, 1) + '*' + user?.name?.slice(2)}</span>
							</li>
							{/*<li>*/}
							{/*	<h5>구매자격</h5> <span>전체 구매 가능</span>*/}
							{/*</li>*/}
						</ul>
					</section>
					<section className="consent">
						<h4>주문관련 동의사항</h4>
						<p>
							<span>1. 아이디공유 및 대리구매 제한</span>
							허가 받지 않은 자와 아이디를 공유하거나 비구매자격자의 부탁을 받아 대리로 구매를 해주는 행위는 이용약관에
							위배되는 사항으로 주문취소 및 자격관리 강등과 회원강제 탈퇴처리 될 수 있습니다.
						</p>
						<p>
							<span>
								2. 특이사항(비용지출처, 주문량의 변동 등)을 확인하기 위해 연락드릴 수 있으니 양해부탁드립니다.
							</span>
						</p>
					</section>
					<section>
						<h4>부가서류 안내</h4>
						<p>
							매출전표는 주문완료 후 마이페이지에서 출력 가능하며, 견적서/거래명세서/사업자등록증 등 추가 서류는
							문의해주시길 바랍니다.
						</p>
					</section>
					<section>
						<h4>전체 동의하기</h4>
						<div className="formWrap">
							<div className="formCheckbox">
								<input type="checkbox" id="itemInfo" required checked={confirmPrice} onChange={e => setConfirmPrice(e.target.checked)}/>
								<label htmlFor="itemInfo"></label>
								<span>
									위 사항을 동의하며<span style={{color: '#1279e6', fontWeight: '700'}}>주문 상품의 상품명, 상품가격</span>을 확인하였습니다.
								</span>
							</div>
							<div className="formCheckbox">
								<input type="checkbox" id="psInfo" required  checked={agreePrivacy} onChange={e => setAgreePrivacy(e.target.checked)}/>
								<label htmlFor="psInfo"></label>
								<span>
									<b onClick={() => setTermsOpen(true)}>개인정보처리방침</b>을 확인하였습니다.
								</span>
							</div>
							<div className="formCheckbox">
								<input type="checkbox" id="refundInfo" required="required" checked={agreeCancel} onChange={e => setAgreeCancel(e.target.checked)}/>
								<label htmlFor="refundInfo"></label>
								<span>
									<b onClick={() => setOpenCancelTermModal(true)}>취소 및 환불규정</b>에 동의합니다.
								</span>
							</div>
						</div>
					</section>
					<div className="shopBtnWrap">
						<button type="submit" onClick={() => {
							if (!isValid) {
								alert('전체 동의를 해주세요.')
							} else {
								setStep(3)
							}
						}}>다음 단계로 이동</button>
					</div>
				</form>
			</div>
			{termsOpen && (
				<TermsModal
					setTermsOpen={setTermsOpen}
					title={"개인정보 수집 및 이용에 관한 안내"}
					text={
						"제 3조 개인정보의 제3자 제공에 관한 사항 \n 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. \n 개인정보를 제3자에게 제공하는 경우 다음의 항목을 이용자에게 알린 후 동의를 받겠습니다. \n "
					}
				/>
			)}

			{openCancelTermModal &&
				<TermsModal
					setTermsOpen={setOpenCancelTermModal}
					title={"취소 및 환불규정"}
					text={
					`
					거래조건에 관한 정보
					
					- 제품하자 오배송 등에 따른 청약철회 등의 경우 청약철회 등을 할 수 있는 기간 및 통신판매업자가 부담하는 반품 비용 등에 관한 정보
					
					전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 제품의 하자 또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가 부담합니다.
					
					
					- 제품하자가 아닌 소비자의 단순변심, 착오구매에 따른 청약철회가 불가능한 경우 그 구체적 사유와 근거
					
					전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에 준하는 것으로 인정되는 경우 청약철회가 제한될 수 있습니다.
					
					
					- 재화 등의 교환, 반품, 보증 조건 및 품질보증기준
					
					소비자분쟁해결기준 (공정거래위원회 고시) 및 관계법령에 따릅니다.
					
					
					- 재화 등의 A/S 관련 전화번호
					050-6607-1258
					
					
					- 대금을 환불받기 위한 방법과 환불이 지연될 경우 지연에 따른 배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적 조건 및 절차
					
					주문취소 및 대금의 환불을 신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한 법률에 따라 소비자의 청약철회 후 판매가자 재화 등을 반환 받은 날로부터 3영업일 이내에 지금받은 대금의 환급을 정당한 사유 없이 지연하는 때에는 소비자는 지연기간에 대해서 20%의 지연배상금을 판매자에게 청구할 수 있습니다.
					
					
					- 소비자피해보상의 처리, 재화 등에 대한 불만처리 및 소비자와 사업자 사이의 분쟁처리에 관한 사항
					
					소비자분쟁해결기준 (공정거래위원회 고시) 및 관계법령에 따릅니다.
					
					
					반품/교환 사유에 따른 요청 가능 기간
					반품 시 먼저 판매자와 연락하셔서 반품사유, 택배사, 배송비, 반품지 주소 등을 협의하신 후 반품상품을 발송해 주시기 바랍니다.

					1. 구매자 단순 변심은 상품 수령 후 7일 이내 (구매자 반품배송비 부담)
					2. 표시/광고와 상이, 상품하자의 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내, 둘 중 하나 경과 시 반품/교환 불가(판매자 반품배송비 부담)



					반품/교환 불가능 사유
 					아래와 같은 경우 반품/교환이 불가능합니다.

					1. 반품요청기간이 지난 경우
					2. 구매자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우 (단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)
					3. 구매자의 책임있는 사유로 포장이 훼손되어 상품 가치가 현저히 상실된 경우 (예: 식품, 화장품, 향수류, 음반 등)
					4. 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우 (라벨이 떨어진 의류 또는 태그가 떨어진 명품관 상품인 경우)
					5. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우
					6. 고객의 요청사항에 맞춰 제작에 들어가는 맞춤제작상품의 경우 (판매자에게 회복불가능한 손해가 예상되고, 그러한 예정으로 청약철회권 행사가 불가하다는 사실을 서면 동의 받은 경우)
					7. 복제가 가능한 상품 등의 포장을 훼손한 경우 (CD/DVD/GAME/도서의 경우 포장 개봉 시)
					`
					}

				/>
			}
		</>
	)
}

export default InfoCheck
